(() => {
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const tabs = [...document.querySelectorAll('.tab')];
function sel(t) { tabs.forEach(x => { const on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; document.getElementById(x.getAttribute('aria-controls')).hidden = !on; }); }
tabs.forEach((t, i) => { t.addEventListener('click', () => sel(t)); t.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; sel(n); n.focus(); } }); });
const cv = document.getElementById('sea'), cx = cv.getContext('2d');
let W, H, mx = 0, my = 0;
function size() { const d = Math.min(devicePixelRatio || 1, 2); W = innerWidth; H = innerHeight; cv.width = W * d; cv.height = H * d; cx.setTransform(d, 0, 0, d, 0, 0); }
size(); addEventListener('resize', size);
addEventListener('pointermove', e => { mx = e.clientX / W - .5; my = e.clientY / H - .5; }, { passive: true });
const snow = Array.from({ length: 160 }, () => ({ x: Math.random(), y: Math.random(), z: Math.random() * .8 + .2, w: Math.random() * 6.28 }));
const cover = document.getElementById('cover');
const mb = document.getElementById('menuBtn'), nv = document.getElementById('mainNav');
if (mb) mb.addEventListener('click', () => { const o = nv.classList.toggle('open'); mb.setAttribute('aria-expanded', o); });
function frame(t) {
const k = Math.min(1, scrollY / Math.max(1, document.documentElement.scrollHeight - H));
const g = cx.createLinearGradient(0, 0, 0, H);
g.addColorStop(0, `rgb(${13 - 11 * k},${58 - 50 * k},${87 - 72 * k})`); g.addColorStop(.5, '#05182a'); g.addColorStop(1, '#01060c');
cx.fillStyle = g; cx.fillRect(0, 0, W, H);
cx.save(); cx.globalCompositeOperation = 'lighter';
const ray = 1 - k * .85;
for (let i = 0; i < 6; i++) {
const x = W * (.12 + i * .16) + Math.sin(t / 3000 + i * 1.7) * 50 + mx * 40;
const gr = cx.createLinearGradient(0, 0, 0, H * .85); gr.addColorStop(0, `rgba(120,220,240,${.075 * ray})`); gr.addColorStop(1, 'rgba(120,220,240,0)');
cx.fillStyle = gr; cx.beginPath(); cx.moveTo(x - 26, 0); cx.lineTo(x + 26, 0); cx.lineTo(x + 170, H); cx.lineTo(x - 60, H); cx.fill();
}
cx.restore();
cx.fillStyle = '#cfeaf2';
for (const p of snow) {
if (!RM) { p.y -= .0008 * p.z; p.w += .01; }
if (p.y < 0) p.y += 1;
const x = (p.x + Math.sin(p.w) * .003 + mx * .02 * p.z) * W, y = (p.y + my * .02 * p.z) * H;
cx.globalAlpha = .15 + p.z * .4; const s = p.z * 1.7; cx.fillRect(x, y, s, s);
}
cx.globalAlpha = 1;
if (!RM && cover) cover.style.transform = `rotateY(${-16 + mx * 10}deg) rotateX(${5 - my * 8}deg)`;
requestAnimationFrame(frame);
}
requestAnimationFrame(frame);
const M = { ctx: null, on: false, timer: null,
build() {
const C = this.ctx = new (window.AudioContext || window.webkitAudioContext)();
this.master = C.createGain(); this.master.gain.value = 0; this.master.connect(C.destination);
const ir = C.createBuffer(2, C.sampleRate * 4, C.sampleRate);
for (let ch = 0; ch < 2; ch++) { const d = ir.getChannelData(ch); for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, 3); }
this.verb = C.createConvolver(); this.verb.buffer = ir; const vg = C.createGain(); vg.gain.value = .55; this.verb.connect(vg).connect(this.master);
const len = C.sampleRate * 6, buf = C.createBuffer(2, len, C.sampleRate);
for (let ch = 0; ch < 2; ch++) { const d = buf.getChannelData(ch); let b0 = 0, b1 = 0, b2 = 0; for (let i = 0; i < len; i++) { const w = Math.random() * 2 - 1; b0 = .99765 * b0 + w * .099; b1 = .963 * b1 + w * .2965; b2 = .57 * b2 + w * 1.0526; d[i] = (b0 + b1 + b2 + w * .1848) * .1; } }
const src = C.createBufferSource(); src.buffer = buf; src.loop = true;
const lp = C.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 650;
const sw = C.createGain(); sw.gain.value = .35;
const l1 = C.createOscillator(); l1.frequency.value = .09; const l1g = C.createGain(); l1g.gain.value = .3; l1.connect(l1g).connect(sw.gain);
const l2 = C.createOscillator(); l2.frequency.value = .06; const l2g = C.createGain(); l2g.gain.value = 320; l2.connect(l2g).connect(lp.frequency);
src.connect(lp).connect(sw).connect(this.master);
src.start(); l1.start(); l2.start();
const pad = C.createGain(); pad.gain.value = .06; const plp = C.createBiquadFilter(); plp.type = 'lowpass'; plp.frequency.value = 900;
const pl = C.createOscillator(); pl.frequency.value = .05; const plg = C.createGain(); plg.gain.value = 500; pl.connect(plg).connect(plp.frequency); pl.start();
[73.42, 110, 146.83, 174.61, 220, 329.63].forEach((f, i) => { [-4, 4].forEach(dt => { const o = C.createOscillator(); o.type = i < 2 ? 'sine' : 'triangle'; o.frequency.value = f; o.detune.value = dt; o.connect(pad); o.start(); }); });
pad.connect(plp); plp.connect(this.master); plp.connect(this.verb);
},
bell() {
const C = this.ctx, notes = [587.33, 659.25, 698.46, 880, 987.77, 1174.66], f = notes[Math.floor(Math.random() * notes.length)], now = C.currentTime;
const o = C.createOscillator(), o2 = C.createOscillator(), g = C.createGain();
o.type = 'sine'; o.frequency.value = f; o2.type = 'sine'; o2.frequency.value = f * 2.01;
g.gain.setValueAtTime(0, now); g.gain.linearRampToValueAtTime(.05, now + .02); g.gain.exponentialRampToValueAtTime(.0001, now + 4.5);
o.connect(g); o2.connect(g); g.connect(this.verb); g.connect(this.master);
o.start(now); o2.start(now); o.stop(now + 5); o2.stop(now + 5);
},
start() {
if (!this.ctx) this.build();
this.ctx.resume(); this.master.gain.setTargetAtTime(.85, this.ctx.currentTime, 1.5); this.on = true;
const loop = () => { if (!this.on) return; this.bell(); this.timer = setTimeout(loop, 3500 + Math.random() * 5000); };
this.timer = setTimeout(loop, 1500);
},
stop() { this.on = false; clearTimeout(this.timer); if (this.ctx) this.master.gain.setTargetAtTime(0, this.ctx.currentTime, .5); } };
const b = document.getElementById('snd');
if (b) b.addEventListener('click', () => { try { if (M.on) { M.stop(); b.setAttribute('aria-pressed', 'false'); } else { M.start(); b.setAttribute('aria-pressed', 'true'); } } catch (e) { document.getElementById('sndlbl').textContent = 'SIN AUDIO'; } });
})();
